import React from 'react';
import { useProgressiveImage } from '../../hooks/useProgressiveImage';

export default function OptimizedImage({
  src,
  alt = '',
  style = {},
  placeholderEmoji = '🍽️',
  borderRadius,
}) {
  const { loaded, error } = useProgressiveImage(src);
  const showImg = src && !error;

  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        borderRadius: borderRadius || 0,
        overflow: 'hidden',
        backgroundColor: '#1A1A1A',
        ...style,
      }}
    >
      {(!loaded || !showImg) && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '40px',
            backgroundColor: '#1A1A1A',
          }}
        >
          {error || !src ? (
            placeholderEmoji
          ) : (
            <div
              style={{
                position: 'absolute',
                inset: 0,
                background: 'linear-gradient(90deg, #1A1A1A 25%, #2A2A2A 50%, #1A1A1A 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 1.5s infinite',
              }}
            />
          )}
        </div>
      )}

      {showImg && (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          decoding="async"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
            transition: 'opacity 0.3s ease, filter 0.3s ease',
            opacity: loaded ? 1 : 0,
            filter: loaded ? 'none' : 'blur(8px)',
          }}
        />
      )}

      <style>{`
        @keyframes shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>
    </div>
  );
}
